import api from './client';

export const getAdminStats = () => api.get('/admin/stats').then(r => r.data);
export const getAdminCompanies = (params) => api.get('/admin/companies', { params }).then(r => r.data);
export const getAdminCompany = (id) => api.get(`/admin/companies/${id}`).then(r => r.data);
export const updateAdminCompany = (id, data) => api.put(`/admin/companies/${id}`, data).then(r => r.data);
export const createAdminCompany = (data) => api.post('/admin/companies', data).then(r => r.data);
export const getPlans = () => api.get('/plans').then(r => r.data);
export const updatePlan = (id, data) => api.put(`/plans/${id}`, data).then(r => r.data);

// API Key yönetimi
export const getCompanyApiKey = (companyId) => api.get(`/admin/companies/${companyId}/api-key`).then(r => r.data);
export const createCompanyApiKey = (companyId) => api.post(`/admin/companies/${companyId}/api-key`).then(r => r.data);
export const deleteCompanyApiKey = (companyId) => api.delete(`/admin/companies/${companyId}/api-key`).then(r => r.data);

// Webhook yönetimi
export const getCompanyWebhook = (companyId) => api.get(`/admin/companies/${companyId}/webhook`).then(r => r.data);
export const saveCompanyWebhook = (companyId, data) => api.post(`/admin/companies/${companyId}/webhook`, data).then(r => r.data);
